import { Route } from 'types/route.type';

import FileSharing from './file-sharing';

export const routes: Route[] = [
  {
    path: '/file-sharing',
    component: FileSharing,
    id: 'fileSharing.title'
  },
];
